import { FormattedMessage } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
const RegionalSupport = () => {
    const localizedHref = useLocalizedHref("/enterprise/support-services");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.regionalSupport.content.body"
                    defaultMessage="Customer support during business hours is available with Confluence Standard plan. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPageTeam24.regionalSupport.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                data-label-english="learn more"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default RegionalSupport;
